import Tablas from "../../Componentes/Tablas"
import { useMonedas } from "./MonedasProvider"
import { StylesGenerales } from "../../Styles/StylesGenerales"
import {Button} from '@material-ui/core'

const MonedasLista = () => {

    const classes = StylesGenerales()
    const {lista,cargando,setDialogCotizacion,setDatosMonedas} = useMonedas()

    const abrirDialogCotizacion = (datos)=>{
        setDatosMonedas(datos)
        setDialogCotizacion(true)
    }

    const columns = [
        {
            field: "id_moneda",
            headerName:"ID"
        },
        {
            field:"activo_moneda",
            headerName:"Moneda principal",
            items:
                {
                    0: "No",
                    1: "Moneda principal"
                }
            ,
            comparaItem: "activo_moneda",
        },
        {
            field:"abreviatura_moneda",
            headerName:"Abre."
        },
        {
            field:"nombre_moneda",
            headerName:"Nombre de moneda"
        },
        {
            field:"valor_moneda",
            headerName:"Valor",
            isNumber:true,
        },
    ]

    const search = (
        <div className={classes.inputs}>
        </div>
    )
    const Acciones = ({filaProps})=>(
    <Button variant="outlined" onClick={()=>{abrirDialogCotizacion(filaProps)}} color="secondary" size="small" >Cotización</Button>
    )

  return (
    <Tablas
        nombretabla="Cotizaciones de monedas"
        subtitle="Moneda principal: Guaraní"
        bgicono="#3f51b5"
        icono="monetization_on"
        columnas={columns}
        cargando={cargando}
        filas={lista}
        Acciones={Acciones}
        namecolumnID="id_moneda"
        search={search}
    />
  )
}

export default MonedasLista
